// extracted by mini-css-extract-plugin
export default {"card":"card___LMXq9","cardCompleteContent":"cardCompleteContent___qCnyX"};